// SHADOW NETWORK — Social i18n strings (ES / EN / SK).
// Used by UserAvatar, FollowButton, ProfileCard, NotificationBell,
// BadgeDisplay, AnalysisSocialBar and future profile pages.
export const i18nShadowSocial = {
  seguir: { es: "Seguir", en: "Follow", sk: "Sledovať", de: "Folgen", "zh-CN": "关注" },
  siguiendo: { es: "Siguiendo", en: "Following", sk: "Sleduješ", de: "Folgend", "zh-CN": "关注中" },
  dejarSeguir: { es: "Dejar de seguir", en: "Unfollow", sk: "Prestať sledovať", de: "Nicht mehr folgen", "zh-CN": "取消关注" },
  seguidores: { es: "seguidores", en: "followers", sk: "sledovateľov", de: "Follower", "zh-CN": "关注者" },
  siguiendoN: { es: "siguiendo", en: "following", sk: "sleduješ", de: "folge ich", "zh-CN": "关注中" },
  analisis: { es: "análisis", en: "analyses", sk: "analýz", de: "Analysen", "zh-CN": "分析" },
  editarPerfil: { es: "Editar perfil", en: "Edit profile", sk: "Upraviť profil", de: "Profil bearbeiten", "zh-CN": "编辑个人资料" },
  winRate: { es: "Win rate", en: "Win rate", sk: "Úspešnosť", de: "Win rate", "zh-CN": "胜率" },
  mejorCall: { es: "Mejor predicción", en: "Best call", sk: "Najlepší tip", de: "Beste Vorhersage", "zh-CN": "最佳预测" },
  racha: { es: "Racha", en: "Streak", sk: "Séria", de: "Serie", "zh-CN": "连胜" },
  guardar: { es: "Guardar", en: "Save", sk: "Uložiť", de: "Speichern", "zh-CN": "保存" },
  guardado: { es: "Guardado", en: "Saved", sk: "Uložené", de: "Gespeichert", "zh-CN": "已保存" },
  like: { es: "Me gusta", en: "Like", sk: "Páči sa mi", de: "Gefällt mir", "zh-CN": "点赞" },
  liked: { es: "Te gusta", en: "Liked", sk: "Páči sa ti", de: "Gefällt dir", "zh-CN": "你喜欢" },
  guardados: { es: "Guardados", en: "Saved", sk: "Uložené", de: "Gespeichert", "zh-CN": "已保存" },
  descubrir: { es: "Descubrir", en: "Discover", sk: "Objaviť", de: "Entdecken", "zh-CN": "发现" },
  feedSiguiendo: { es: "Siguiendo", en: "Following", sk: "Sledovaní", de: "Folge ich", "zh-CN": "关注中" },
  notificaciones: { es: "Notificaciones", en: "Notifications", sk: "Upozornenia", de: "Benachrichtigungen", "zh-CN": "通知" },
  sinNotif: { es: "Sin notificaciones", en: "No notifications", sk: "Žiadne upozornenia", de: "Keine Benachrichtigungen", "zh-CN": "暂无通知" },
  completaPerfil: { es: "Completa tu perfil", en: "Complete your profile", sk: "Dokonči profil", de: "Vervollständige dein Profil", "zh-CN": "完善你的个人资料" },
  sugerencias: { es: "Sugerencias para seguir", en: "Suggested traders", sk: "Navrhovaní obchodníci", de: "Vorschläge zum Folgen", "zh-CN": "推荐关注" },
  buscarTraders: {
    es: "Buscar traders…",
    en: "Search traders…",
    sk: "Hľadať obchodníkov…", de: "Trader suchen…", "zh-CN": "搜索交易者…",
  },
  marcarLeidas: {
    es: "Marcar todas como leídas",
    en: "Mark all as read",
    sk: "Označiť všetky ako prečítané", de: "Alle als gelesen markieren", "zh-CN": "全部标记为已读",
  },
  verPerfil: { es: "Ver perfil", en: "View profile", sk: "Zobraziť profil", de: "Profil ansehen", "zh-CN": "查看个人资料" },
  verificado: { es: "Verificado", en: "Verified", sk: "Overené", de: "Verifiziert", "zh-CN": "已验证" },
  // Direct messages
  mensajes: { es: "Mensajes", en: "Messages", sk: "Správy", de: "Nachrichten", "zh-CN": "消息" },
  enviarMensaje: { es: "Enviar mensaje", en: "Send message", sk: "Poslať správu", de: "Nachricht senden", "zh-CN": "发送消息" },
  escribeMensaje: { es: "Escribe un mensaje…", en: "Write a message…", sk: "Napíš správu…", de: "Schreibe eine Nachricht…", "zh-CN": "输入消息…" },
  enviar: { es: "Enviar", en: "Send", sk: "Odoslať", de: "Senden", "zh-CN": "发送" },
  sinMensajes: { es: "Sin mensajes aún", en: "No messages yet", sk: "Zatiaľ žiadne správy", de: "Noch keine Nachrichten", "zh-CN": "暂无消息" },
  sinConversaciones: {
    es: "Aún no tienes conversaciones",
    en: "No conversations yet",
    sk: "Zatiaľ žiadne konverzácie", de: "Du hast noch keine Unterhaltungen", "zh-CN": "你还没有任何对话",
  },
  cifradoBadge: {
    es: "MENSAJES CIFRADOS AES-256",
    en: "AES-256 ENCRYPTED MESSAGES",
    sk: "SPRÁVY ŠIFROVANÉ AES-256", de: "AES-256 VERSCHLÜSSELTE NACHRICHTEN", "zh-CN": "AES-256 加密消息",
  },
  cifradoEndToEnd: {
    es: "Cifrado de extremo a extremo",
    en: "End-to-end encrypted",
    sk: "Šifrované end-to-end", de: "Ende-zu-Ende-Verschlüsselung", "zh-CN": "端到端加密",
  },
  enterParaEnviar: {
    es: "Enter para enviar",
    en: "Enter to send",
    sk: "Enter na odoslanie", de: "Enter zum Senden", "zh-CN": "Enter 键发送",
  },
  // Notification messages
  notifNewFollower: {
    es: "te ha seguido",
    en: "started following you",
    sk: "ťa začal sledovať", de: "folgt dir jetzt", "zh-CN": "关注了你",
  },
  notifLikeAnalysis: {
    es: "le gustó tu análisis",
    en: "liked your analysis",
    sk: "páči sa mu tvoja analýza", de: "gefällt deine Analyse", "zh-CN": "赞了你的分析",
  },
  notifCommentAnalysis: {
    es: "comentó tu análisis",
    en: "commented on your analysis",
    sk: "okomentoval tvoju analýzu", de: "hat deine Analyse kommentiert", "zh-CN": "评论了你的分析",
  },
  notifMention: { es: "te mencionó", en: "mentioned you", sk: "ťa spomenul", de: "hat dich erwähnt", "zh-CN": "提到了你" },
  notifBadgeUnlocked: {
    es: "🏅 Has desbloqueado un nuevo badge",
    en: "🏅 You unlocked a new badge",
    sk: "🏅 Odomkol si nový odznak", de: "🏅 Du hast ein neues Badge freigeschaltet", "zh-CN": "🏅 你已解锁新徽章",
  },
  notifNewAnalysisFromFollowing: {
    es: "publicó un nuevo análisis",
    en: "published a new analysis",
    sk: "zverejnil novú analýzu", de: "hat eine neue Analyse veröffentlicht", "zh-CN": "发布了新分析",
  },
  notifRankingChange: {
    es: "📈 Has cambiado de posición en el ranking",
    en: "📈 Your ranking position changed",
    sk: "📈 Tvoja pozícia v rebríčku sa zmenila", de: "📈 Du hast deine Position im Ranking geändert", "zh-CN": "📈 你在排行榜上的排名发生了变化",
  },
  notifWyckoffMajorSetup: {
    es: "🏆 Nuevo setup dorado de compresión mayor (Wyckoff)",
    en: "🏆 New major-compression setup (Wyckoff)",
    sk: "🏆 Nový major-compression setup (Wyckoff)", de: "🏆 Neues goldenes Kompressions-Setup (Wyckoff)", "zh-CN": "🏆 新的黄金压缩设置（Wyckoff）",
  },
  notifCyclesEvent: {
    es: "🌀 Evento macro detectado en el Cycles Map",
    en: "🌀 Macro event detected on the Cycles Map",
    sk: "🌀 Makro udalosť zistená v Cycles Map", de: "🌀 Makro-Ereignis auf der Cycles Map erkannt", "zh-CN": "🌀 在 Cycles Map 中检测到宏观事件",
  },
  notifProBroadcast: {
    es: "📢 Aviso RE₿EL para operadores PRO",
    en: "📢 RE₿EL announcement for PRO operators",
    sk: "📢 RE₿EL oznámenie pre PRO operátorov", de: "📢 RE₿EL-Hinweis für PRO-Trader", "zh-CN": "📢 RE₿EL PRO 操作员公告",
  },
  // Tip Jar
  tipJarTitle: {
    es: "💰 Apoyar a este operador",
    en: "💰 Tip this operator",
    sk: "💰 Podpor tohto operátora", de: "💰 Diesen Trader unterstützen", "zh-CN": "💰 支持这位操作员",
  },
  tipJarSubtitle: {
    es: "Envía USDC directamente a su wallet. Sin intermediarios, sin comisiones.",
    en: "Send USDC directly to their wallet. No middlemen, no fees.",
    sk: "Pošli USDC priamo do peňaženky. Bez sprostredkovateľov, bez poplatkov.", de: "Sende USDC direkt an sein Wallet. Keine Vermittler, keine Gebühren.", "zh-CN": "直接向其钱包发送 USDC。无中介，无手续费。",
  },
  tipJarChain: { es: "Red", en: "Network", sk: "Sieť", de: "Netzwerk", "zh-CN": "网络" },
  tipJarAddress: { es: "Dirección", en: "Address", sk: "Adresa", de: "Adresse", "zh-CN": "地址" },
  tipJarCopy: { es: "Copiar dirección", en: "Copy address", sk: "Kopírovať adresu", de: "Adresse kopieren", "zh-CN": "复制地址" },
  tipJarCopied: { es: "¡Copiado!", en: "Copied!", sk: "Skopírované!", de: "Kopiert!", "zh-CN": "已复制！" },
  tipJarOpen: { es: "Abrir en wallet", en: "Open in wallet", sk: "Otvoriť v peňaženke", de: "In Wallet öffnen", "zh-CN": "在钱包中打开" },
  tipJarQrHint: {
    es: "Escanea el QR con tu wallet o copia la dirección",
    en: "Scan QR with your wallet or copy the address",
    sk: "Naskenuj QR alebo skopíruj adresu", de: "Scanne den QR-Code mit deinem Wallet oder kopiere die Adresse", "zh-CN": "用你的钱包扫描二维码或复制地址",
  },
  tipJarDisclaimer: {
    es: "Verifica siempre la dirección antes de enviar. Solo USDC en la red indicada.",
    en: "Always verify the address before sending. USDC only, on the indicated network.",
    sk: "Vždy over adresu pred odoslaním. Iba USDC v uvedenej sieti.", de: "Überprüfe immer die Adresse, bevor du sendest. Nur USDC im angegebenen Netzwerk.", "zh-CN": "发送前请务必验证地址。仅限指定网络上的 USDC。",
  },
  tipJarEditTitle: { es: "Tip Jar (opcional)", en: "Tip Jar (optional)", sk: "Tip Jar (voliteľné)", de: "Tip Jar (optional)", "zh-CN": "打赏罐（可选）" },
  tipJarEditHelp: {
    es: "Permite que otros operadores te envíen USDC. Solo dirección EVM (Base, Polygon, Ethereum, Arbitrum, Optimism).",
    en: "Let other operators send you USDC. EVM address only (Base, Polygon, Ethereum, Arbitrum, Optimism).",
    sk: "Umožni operátorom posielať ti USDC. Iba EVM adresa (Base, Polygon, Ethereum, Arbitrum, Optimism).", de: "Ermöglicht es anderen Tradern, dir USDC zu senden. Nur EVM-Adresse (Base, Polygon, Ethereum, Arbitrum, Optimism).", "zh-CN": "允许其他操作员向你发送 USDC。仅限 EVM 地址（Base、Polygon、Ethereum、Arbitrum、Optimism）。",
  },
  // ImageCropperModal
  cropTitleAvatar: { es: "Recortar foto de perfil", en: "Crop profile photo", sk: "Orezať profilovú fotku", de: "Profilbild zuschneiden", "zh-CN": "裁剪头像" },
  cropTitleBanner: { es: "Recortar foto de portada", en: "Crop cover photo", sk: "Orezať obal", de: "Titelbild zuschneiden", "zh-CN": "裁剪封面图片" },
  cropHint: {
    es: "Arrastra para reposicionar · usa el zoom para encuadrar",
    en: "Drag to reposition · use zoom to frame",
    sk: "Ťahaj na zmenu pozície · použi zoom na zarámovanie", de: "Ziehen zum Repositionieren · Zoom zum Einrahmen verwenden", "zh-CN": "拖动以重新定位 · 使用缩放调整构图",
  },
  cropZoom: { es: "Zoom", en: "Zoom", sk: "Zoom", de: "Zoom", "zh-CN": "缩放" },
  cropApply: { es: "Aplicar recorte", en: "Apply crop", sk: "Použiť orezanie", de: "Zuschnitt anwenden", "zh-CN": "应用裁剪" },
  cropCancel: { es: "Cancelar", en: "Cancel", sk: "Zrušiť", de: "Abbrechen", "zh-CN": "取消" },
  cropProcessing: { es: "Procesando…", en: "Processing…", sk: "Spracúvam…", de: "Verarbeitung…", "zh-CN": "处理中…" },
  uploadFailedGeneric: {
    es: "No se pudo subir la imagen. Inténtalo de nuevo.",
    en: "Couldn't upload the image. Please try again.",
    sk: "Obrázok sa nepodarilo nahrať. Skús znova.", de: "Bild konnte nicht hochgeladen werden. Versuche es erneut.", "zh-CN": "无法上传图片。请重试。",
  },
};

export const tShadow = (key, lang = "es") => {
  const node = i18nShadowSocial[key];
  if (!node) return key;
  return node[lang] || node.en || node.es || key;
};
